<template>
  <v-app light style="background:transparent !important">
    <router-view></router-view>
  </v-app>
</template>

<script>

 export default {
   data () {
     return {
    }
   }
 }
</script>
